<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit }" v-if="!success && form.token && form.email">
            <form @submit.prevent="handleSubmit(submit)" action="#" class="login-form" :class="{'loading': loading}">

                <div class="row">
                    <ValidationProvider
                        :name="$t('Password')"
                        rules="required|min:8"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }"
                        vid="password">

                        <input v-model="form.password" type="password" name="password" :placeholder="$t('Password') + '*'" class="form-control" :class="{ 'is-invalid': resetPasswordErrors && resetPasswordErrors.password }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="resetPasswordErrors && resetPasswordErrors.password">
                            {{ resetPasswordErrors.password[0] }}
                        </div>

                    </ValidationProvider>

                    <ValidationProvider
                        :name="$t('Confirm password')"
                        rules="required|confirmed:password"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }"
                        vid="confirmation">

                        <input v-model="form.password_confirmation" type="password" name="password_confirmation" :placeholder="$t('Confirm password') + '*'" class="form-control" :class="{ 'is-invalid': resetPasswordErrors && resetPasswordErrors.password_confirmation }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="resetPasswordErrors && resetPasswordErrors.password_confirmation">
                            {{ resetPasswordErrors.password_confirmation[0] }}
                        </div>
                    </ValidationProvider>
                </div>
                <div class="alert alert-danger" v-if="resetPasswordErrors && ( resetPasswordErrors.token || resetPasswordErrors.email )">
                    {{ resetPasswordErrors.token ? resetPasswordErrors.token[0] : '' }}
                    {{ resetPasswordErrors.email ? resetPasswordErrors.email[0] : '' }}
                </div>

                <google-re-captcha-v3
                    v-model="form.gRecaptchaResponse"
                    ref="captcha"
                    site-key="6LcYc50aAAAAAEO4r8anAbWprxsv_cbDse5KqSMP"
                    id="reset_password_id"
                    inline
                    action="reset_password"
                ></google-re-captcha-v3>

                <button type="submit" class="btn btn-primary mt-2" :disabled="formSubmitting">
                    <span v-if="!formSubmitting">{{ $t('Reset password') }}</span>
                    <span v-else>{{ $t('Reset password') }}...</span>
                </button>
            </form>
        </ValidationObserver>

        <div class="alert alert-warning" role="alert" v-else-if="!success && !form.token && !form.email">
            {{ $t('Please request a (new) reset password link for') }}: <router-link :to="{ name: 'users.forgotPassword' }">{{ $t('Forgot password') }}</router-link>
        </div>
        <div class="alert alert-success" role="alert" v-else>
            {{ $t('Your password has been reset successfully. You can sign in with your new password now.') }}
        </div>
    </div>

</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import GoogleReCaptchaV3 from "../googlerecaptchav3/GoogleReCaptchaV3";

export default {
    name: 'ResetPasswordForm',
    components: {
        GoogleReCaptchaV3
    },

    data() {
        return {
            form: {
                token: '',
                email: '',
                password: '',
                password_confirmation: '',
                gRecaptchaResponse: null,
            },
            captchaRef: null,
            resetPasswordErrors: [],
            formSubmitting: false,
            success: false,
            loading: false,
        }
    },

    created () {
        this.form.email = this.$route.query.email;
        this.form.token = this.$route.query.token;
    },

    computed: {

        ...mapGetters({
            formErrors: 'auth/formErrors',
            authenticated: 'auth/authenticated',
            permissions: 'auth/permissions'
        }),

    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn'
        }),

        submit () {

            this.formSubmitting = true;
            this.loading = true;
            this.setCaptchaRef();

            axios.post('/api/forgot_password/reset', this.form)
                .then(response => {
                    this.formSubmitting = false;
                    this.loading = false;
                    this.success = true;
                }).catch( error => {
                if (error.response.status === 422) { // Validation Error
                    this.resetPasswordErrors = error.response.data.errors;
                    this.formSubmitting = false;
                }
                this.loading = false;
            });
            this.captchaRef.execute();
            // Set login form state
            this.formSubmitting = false;

        },

        setCaptchaRef() {
            let captcha = this.$refs.captcha

            if (captcha && !this.captchaRef) {
                this.captchaRef = captcha;
            }
        },

    },


}
</script>
